<template>
  <div class="staff-edit" v-if="dataPermission && dataPermission.includes('CNPS_SUR_STAFF_UPSERT')">
    <div class="breadcrumb-area pos-relative" style="width: 100%">
      <h1>Sửa thông tin nhân viên</h1>
      <div style="float: right">
        <button
          class="f12 font-medium btn btn-primary rounded-pill btn-sm-fix btn-link"
          @click="editStaff"
        >
          <i class="bx bx-check"></i> Lưu
        </button>
        <button
          class="f12 ml-2 font-medium btn btn-outline-secondary rounded-pill"
          @click="$router.push('/staff')"
        >
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <!-- End Breadcrumb Area -->
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="formAdd">
        <div class="card-body">
          <form @submit.prevent="editStaff" class="row">
            <div class="col-md-4">
              <h4 class="form-inner-heading">Cá nhân</h4>
              <ValidationProvider rules="" vid="name" name="Họ và tên">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Họ và tên<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model="dataEdit.name" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required|mail_3" vid="userName" name="Email">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Email<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model.trim="dataEdit.userName" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="dateOfBirth" name="Ngày tháng năm sinh">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày tháng năm sinh</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataEdit.dateOfBirth"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="regexNumber" vid="identifyCard" name="Số CMND/CCCD/HC">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Số CMND/CCCD/HC</label>
                  <div class="col-sm-7">
                    <input v-model="dataEdit.identifyCard" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="timeRange" name="Ngày cấp">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày cấp</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataEdit.timeRange"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="place" name="Nơi cấp">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Nơi cấp</label>
                  <div class="col-sm-7">
                    <input v-model="dataEdit.place" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="gender" name="Giới tính">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Giới tính<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2 v-model="dataEdit.gender" :options="dataConfigGender"> </Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="mobile" name="Số điện thoại">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Số điện thoại<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model.trim="dataEdit.mobile" type="text" class="form-control" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="address" name="Địa chỉ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Địa chỉ</label>
                  <div class="col-sm-7">
                    <input disabled v-model="dataEdit.address" type="text" class="form-control" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="levelEmployee" name="Cấp bậc nhân viên">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Cấp bậc nhân viên<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2
                      v-model="dataEdit.levelEmployee"
                      :options="dataLevelEmployee"
                    ></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-4">
              <h4 class="form-inner-heading">Công ty</h4>
              <ValidationProvider rules="" vid="companyCode" name="Mã nhân viên">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã nhân viên<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <input v-model="dataEdit.companyCode" disabled />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="companyDayIn" name="Ngày vào công ty">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngày vào công ty <span class="ml-1" style="color: red">*</span></label
                  >
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataEdit.companyDayIn"
                      placeholder="Chọn ngày vào công ty"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="officialTime" name="Ngày lên chính thức">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày lên chính thức</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataEdit.officialTime"
                      placeholder="Chọn ngày lên chính thức"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="signContractTime" name="Ngày ký HĐLĐ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày ký HĐLĐ</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataEdit.signContractTime"
                      placeholder="Chọn ngày ký HĐLĐ"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="contractPeriod" name="Thời hạn HĐ">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Thời hạn HĐ</label>
                  <div class="col-sm-7">
                    <Select2 v-model="dataEdit.contractPeriod" :options="optionPeriod"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="resignDate" name="Ngày nghỉ việc">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ngày nghỉ việc</label>
                  <div class="col-sm-7">
                    <datepicker
                      format="dd/MM/yyyy"
                      :language="vi"
                      v-model="dataEdit.resignDate"
                      placeholder="Chọn ngày nghỉ việc"
                      :clearButton="true"
                    ></datepicker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider
                rules="regexNumber2"
                vid="leaveDay"
                name="Số ngày nghỉ phép còn lại"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Số ngày nghỉ phép còn lại</label>
                  <div class="col-sm-7">
                    <input v-model="dataEdit.leaveDay" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="typeSale" name="Vai trò">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vai trò<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2 v-model="dataEdit.typeSale" :options="dataRole" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="companyPhase" name="Vị trí">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vị trí<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2 v-model="dataEdit.companyPhase" :options="optionComphase"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="superior" name="Người quản lý">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Người quản lý<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <select2
                      v-model="dataEdit.superior"
                      :options="dataManager"
                      :settings="superiorSettings"
                      placeholder="Tìm kiếm người quản lý"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="region" name="Vùng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vùng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <select2-multiple-control
                      @change="
                        queryProvince($event),
                          checkMainHasValue(dataEdit, 'regionMain', dataEdit.region)
                      "
                      v-model="dataEdit.region"
                      :options="dataRegion"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="regionMain" name="Vùng chính">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Vùng chính<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2
                      v-model="dataEdit.regionMain"
                      :options="filterSelected(dataEdit.region, dataRegion)"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="province" name="Tỉnh/Thành phố">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tỉnh/Thành phố<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <select2-multiple-control
                      v-model="dataEdit.province"
                      :options="dataProvince"
                      @change="
                        convertDataProvice($event),
                          checkMainHasValue(dataEdit, 'provinceMain', dataEdit.province)
                      "
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                    <!-- <p class="text-danger">{{ errorProvince }}</p> -->
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="provinceMain" name="Tỉnh/Thành phố chính">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tỉnh/Thành phố chính<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-7">
                    <Select2
                      v-model="dataEdit.provinceMain"
                      :options="filterSelected(dataEdit.province, dataProvince)"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="numberCheck" name="Leads / Ngày">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-4 col-form-label"
                    >Leads /
                    <span v-if="dataEdit.userKPI">{{
                      dataEdit.userKPI.leadUnit | mapTextStatus(dataUnit)
                    }}</span>
                    <span v-else>Ngày</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="number"
                      min="0"
                      class="form-control"
                      v-model="dataEdit.kpiReq.lead"
                      placeholder="Leads/Ngày"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="numberCheck" name="Công việc / Ngày">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-4 col-form-label"
                    >Công việc /
                    <span v-if="dataEdit.userKPI">{{
                      dataEdit.userKPI.workUnit | mapTextStatus(dataUnit)
                    }}</span>
                    <span v-else>Ngày</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="number"
                      class="form-control"
                      min="0"
                      v-model="dataEdit.kpiReq.work"
                      placeholder="Công việc/Ngày"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="numberCheck" name="KPI / Tháng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-4 col-form-label"
                    >KPI /
                    <span v-if="dataEdit.userKPI">{{
                      dataEdit.userKPI.kpiUnit | mapTextStatus(dataUnit)
                    }}</span>
                    <span v-else>Tháng</span>
                  </label>
                  <div class="col-sm-8">
                    <input
                      type="number"
                      class="form-control"
                      min="0"
                      v-model="dataEdit.kpiReq.kpi"
                      placeholder="KPI/Tháng"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>

              <div class="form-group row">
                <label for class="col-sm-4 col-form-label">Tracking</label>
                <div class="col-sm-8 d-flex align-items-center">
                  <b-form-checkbox
                    size="lg"
                    v-model="dataEdit.isTracking"
                    name="check-button"
                    switch
                  >
                  </b-form-checkbox>
                </div>
              </div>

              <div class="form-group row">
                <label for class="col-sm-4 col-form-label">Chấm công</label>
                <div class="col-sm-8 d-flex align-items-center">
                  <b-form-checkbox
                    size="lg"
                    v-model="dataEdit.isTimeKeep"
                    name="check-button"
                    switch
                  >
                  </b-form-checkbox>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <h4 class="form-inner-heading">Ảnh</h4>
              <h4 class="form-inner-heading">Ảnh nhân viên</h4>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in avtStaff" :key="index">
                    <a>
                      <img :src="item" />
                      <span @click="removeImg(index, 'nhanVien')">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div v-else-if="avtStaff && avtStaff.length < 1" class="add-img">
                      <span class="bx bx-plus text-center"></span>
                      <input
                        type="file"
                        ref="fileInput1"
                        accept="image/jpeg, image/png"
                        @input="onSelectAvt"
                      />
                    </div>
                  </li>
                </ul>
              </div>

              <h4 class="form-inner-heading">Ảnh chứng chỉ</h4>

              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in dataEdit.certificateImages" :key="index">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="item" />
                      <span @click="removeImg(index, 'chungChi')">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        !dataEdit.certificateImages || dataEdit.certificateImages.length < 5
                      "
                      class="add-img"
                    >
                      <span class="bx bx-plus text-center"></span>
                      <input
                        type="file"
                        ref="fileInput"
                        accept="image/jpeg, image/png"
                        @input="onSelectFile"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>
      </ValidationObserver>
    </div>

    <b-modal id="modal-scoped" centered v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button type="button" class="close" @click="close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="modal-body text-center">
        <img src="@/assets/noti-success2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">Sửa thông tin thành công</h2>
      </div>
      <template #modal-footer="{}">
        <b-button variant="light" @click="$router.push('/staff')"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '../../thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import { CommonService } from '@/services/common.service'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import reuseMx from './reuseMx.js'
  import cloneDeep from 'lodash/cloneDeep'
  import moment from 'moment'

  import { SearchStaff } from '@/services/customer-support/staff'
  import { showMess } from '@/config/utils'

  export default {
    mixins: [reuseMx],
    data() {
      return {
        userId: '',
        dataEdit: {
          province: [],
          kpiReq: {},
          leaveDay: '',
        },
        vi: vi,
        dataLevelEmployee: Config.levelEmployee,
        dataConfigGender: Config.configGender,
        optionComphase: Config.optionComphase,
        optionPeriod: Config.contractPeriod,
        dataRegion: [],
        dataProvince: [],
        objectMesserr: {},
        dataManager: [],
        showModal: false,
        insertSuccess: {},
        dataRole: [],
        messErr: '',
        dataAddKPI: {
          kpi: null,
          lead: null,
          work: null,
        },
        showLoading: false,
        provinceSelectedData: [],
        dataUnit: Config.dataUnit,
        loadingImage: false,
        errorProvince: '',
        avtStaff: [],

        tLoadSuperior: undefined,
        superiorSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              // if (!txtSearch) {
              //   return success({
              //     results: [],
              //   });
              // }

              if (this.tLoadSuperior) {
                clearTimeout(this.tLoadSuperior)
              }

              this.tLoadSuperior = setTimeout(() => {
                SearchStaff({
                  keyWord: txtSearch,
                  limit: 10,
                })
                  .then(res => {
                    if (res.code == 1000) {
                      success({
                        results: res.data.map(user => {
                          return {
                            id: user.userName,
                            text: user.name || user.userName,
                          }
                        }),
                      })
                    } else {
                      showMess(
                        this,
                        'Thông báo',
                        res?.data?.message || res.message,
                        'danger',
                        'b-toaster-top-right',
                        5 * 60 * 60
                      )
                    }
                  })
                  .catch(error => {
                    showMess(
                      this,
                      'Thông báo',
                      error?.response?.message || error.message,
                      'danger',
                      'b-toaster-top-right',
                      5 * 60 * 60
                    )
                  })
              }, 500)
            },
          },
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
      }
    },

    async created() {
      this.fetchData()
      // this.superiors()
      if (this.dataEdit.name) {
        const dataQuery = await StaffService.getStaffById({
          userId: this.dataEdit.id,
        })
        if (dataQuery.success) {
          this.dataEdit = dataQuery.data
          this.dataEdit.userName = this.dataEdit.username
          this.queryProvince(this.dataEdit.region)
        }
      }
      this.getRegion()
      this.getTypeSale()
    },

    computed: {
      ...mapGetters({
        // dataEdit: 'user/dataEditStaff',
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async onSelectFile() {
        const input = this.$refs.fileInput
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0], 'chungChi')
      },

      async onSelectAvt() {
        const input = this.$refs.fileInput1
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0], 'nhanVien')
      },

      removeImg(index, type) {
        if (type === 'chungChi') {
          this.dataEdit.certificateImages.forEach((item, i) => {
            if (index === i) {
              this.dataEdit.certificateImages.splice(i, 1)
            }
          })
        } else {
          this.avtStaff = []
        }
      },

      async uploadS3(file, type) {
        try {
          if (file) {
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              if (type === 'chungChi') {
                this.dataEdit.certificateImages.push(res.data[0])
              } else {
                this.avtStaff.push(res.data[0])
              }
            }
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      // async superiors () {
      //   try {
      //     const data = await StaffService.superiors()
      //     if (data.data.length > 0) {
      //       this.dataManager = data.data.map(e => {
      //         return {
      //           id: e.userName,
      //           text: e.name
      //         }
      //       })
      //     }
      //   } catch (error) {}
      // },
      async getTypeSale() {
        try {
          const data = await CommonService.getTypeSale({})
          console.log('this.dataUser?.typeSale', this.dataUser?.typeSale)
          if (data.data.length > 0) {
            this.dataRole = data.data
              .filter(i => {
                if (i.code === 'REGION_DIRECTOR') {
                  return (
                    this.dataUser?.typeSale === 'SALE_DIRECTOR' ||
                    this.dataUser?.typeSale === 'REGION_DIRECTOR'
                  )
                }
                return true
              })
              .map(e => ({
                id: e.code,
                text: e.name,
              }))
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async getRegion() {
        try {
          const data = await StaffService.getRegions()
          if (data.data.length > 0) {
            this.dataRegion = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({
            regionId: e,
          })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: 'ALL', text: 'Tất cả' })
          } else {
            delete this.dataEdit.region
            delete this.dataEdit.province
            this.dataProvince = []
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },

      convertDataProvice(e) {
        if (e?.length === 0) {
          delete this.dataEdit.province
          this.errorProvince = ''
        } else {
          if (e.includes('ALL')) this.dataEdit.province = ['ALL']
        }
      },

      closeModalAdd() {
        this.showModal = false
        this.$router.push('/staff')
      },
      async editStaff() {
        if (this.dataEdit.province?.length > 0) {
          if (this.dataEdit.province.includes('ALL')) {
            const dataProvince = this.dataProvince?.filter(e => e.id !== 'ALL')
            this.dataEdit.province = dataProvince?.map(e => {
              return e.id
            })
          }
        } else {
          delete this.dataEdit.province
          this.errorProvince = 'Tỉnh/Thành phố không được để trống'
        }
        // check provinceMain and regionMain
        const provinceList = this.dataProvince?.map(e => e.id)
        this.dataEdit.province = this.dataEdit.province?.filter(p => provinceList.includes(p))
        this.checkMainHasValue(this.dataEdit, 'regionMain', this.dataEdit.region)
        this.checkMainHasValue(this.dataEdit, 'provinceMain', this.dataEdit.province)
        await this.$nextTick()

        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) {
          return
        }
        if (this.dataEdit.leaveDay && this.dataEdit.leaveDay !== '') {
          const check = /^[0-9]+(\.[0-9]+)?$/.test(this.dataEdit.leaveDay)
          if (!check) {
            return
          }
        }
        const submit = await this.approveMx('Bạn chắc chắn muốn cập nhật nhân viên này?')
        if (submit) {
          this.submitInsert()
        }
      },
      async submitInsert() {
        try {
          this.showLoading = true
          this.dataEdit.avatarUrl = this.avtStaff[0]
          this.convertDataBeforeSubmit()

          if (this.dataEdit.province.includes('ALL')) {
            const dataProvince = this.dataProvince?.filter(e => e.id !== 'ALL')
            this.dataEdit.province = dataProvince?.map(e => {
              return e.id
            })
          }
          const params = cloneDeep(this.dataEdit)
          if (this.dataEdit.levelEmployee)
            params.levelEmployee = Number(this.dataEdit.levelEmployee)
          const data = await StaffService.addStaff(params)

          if (data.data.result) {
            this.showModal = true
          } else {
            this.showFailMx(data.data.message)
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.showLoading = false
        }
      },

      convertDataBeforeSubmit() {
        this.dataEdit.companyDayIn = moment(this.dataEdit.companyDayIn).startOf('day').valueOf()
        this.dataEdit.dateOfBirth = new Date(this.dataEdit.dateOfBirth).getTime()

        if (this.dataEdit.signContractTime)
          this.dataEdit.signContractTime = new Date(this.dataEdit.signContractTime).getTime()
        if (this.dataEdit.officialTime !== 0)
          this.dataEdit.officialTime = new Date(this.dataEdit.officialTime).getTime()
        if (this.dataEdit.companyDayIn)
          this.dataEdit.companyDayIn = moment(this.dataEdit.companyDayIn).startOf('day').valueOf()
        if (this.dataEdit.timeRange)
          this.dataEdit.timeRange = new Date(this.dataEdit.timeRange).getTime()
        if (this.dataEdit.resignDate)
          this.dataEdit.resignDate = new Date(this.dataEdit.resignDate).getTime()

        if (!this.dataAddKPI.kpi && !this.dataAddKPI.lead && !this.dataAddKPI.work) {
          this.dataEdit.kpiReq = {}
        } else {
          this.dataAddKPI.kpi
            ? (this.dataEdit.kpiReq.kpi = Number(this.dataAddKPI.kpi))
            : delete this.dataEdit.kpiReq.kpi
          this.dataAddKPI.lead
            ? (this.dataEdit.kpiReq.lead = Number(this.dataAddKPI.lead))
            : delete this.dataEdit.kpiReq.lead
          this.dataAddKPI.work
            ? (this.dataEdit.kpiReq.work = Number(this.dataAddKPI.work))
            : delete this.dataEdit.kpiReq.work
        }
      },
      async fetchData() {
        try {
          this.userId = this.$route.query.id
          const dataQuery = await StaffService.getStaffById({
            userId: this.userId,
          })
          if (dataQuery.success) {
            this.dataEdit = dataQuery.data
            if (this.dataEdit.signContractTime === 0) {
              this.dataEdit.signContractTime = null
            }
            if (this.dataEdit.officialTime === 0) {
              this.dataEdit.officialTime = null
            }
            if (this.dataEdit.timeRange === 0) {
              this.dataEdit.timeRange = null
            }
            if (dataQuery.data.levelEmployee || dataQuery.data.levelEmployee === 0) {
              this.dataEdit.levelEmployee = String(dataQuery.data.levelEmployee)
              console.log(this.dataEdit)
            }
            if (dataQuery.data.avatarUrl) {
              this.avtStaff.push(dataQuery.data.avatarUrl)
            }
            if (dataQuery.data.userKPI) {
              this.dataEdit.kpiReq = { ...dataQuery.data.userKPI }
            } else {
              this.dataEdit.kpiReq = {
                kpi: null,
                lead: null,
                work: null,
              }
            }
            await this.queryProvince(this.dataEdit.region)
            const dataProvince_2 = this.dataProvince
              .filter(e => e.id !== 'ALL')
              .map(e => {
                return e.id
              })
            const sameArray =
              this.dataEdit.province.length === dataProvince_2.length &&
              this.dataEdit.province.every((value, index) => value === dataProvince_2[index])
            if (sameArray) this.dataEdit.province = ['ALL']

            this.dataManager = [
              {
                id: this.dataEdit.superior,
                text: this.dataEdit.superiorName,
              },
            ]
          }
        } catch (error) {
          showMess(
            this,
            'Thông báo',
            error?.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
    },
  }
</script>

<style scoped>
  .col-form-label {
    padding-top: calc(0.375rem + 1px);
    padding-bottom: calc(0.375rem + 1px);
    margin-bottom: 0;
    font-size: inherit;
    line-height: 1.5;
  }

  .form-inner-heading {
    font-size: 16px;
    padding-bottom: 20px;
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
</style>
